export default __webpack_public_path__ + "static/media/640_store04-nl-web.ada67d03.png";